/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneType,
  PhoneTypeOptional,
  PhoneTypeMetaI,
  PhoneTypeTrackedI,
} from "./phone-type";
import { PhoneTypeTracked, PhoneTypeMeta } from "./phone-type";

/**
 *
 * @export
 * @interface PhoneBase
 */
export interface PhoneBaseOptional {
  /**
   *
   * @type {string}
   * @memberof PhoneBase
   */
  number?: string;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneBase
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isBad?: boolean;
}

export interface PhoneBase extends PhoneBaseOptional {
  /**
   *
   * @type {string}
   * @memberof PhoneBase
   */
  number: string;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneBase
   */
  type?: PhoneType;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isVerified?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isBad?: boolean;
}

export interface PhoneBaseTrackedI {
  /**
   *
   * @type {string}
   * @memberof PhoneBase
   */
  number?: string;
  numberIsSet: boolean;
  /**
   *
   * @type {PhoneType}
   * @memberof PhoneBase
   */
  type?: PhoneType;
  typeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isVerified?: boolean;
  isVerifiedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PhoneBase
   */
  isBad?: boolean;
  isBadIsSet: boolean;
}

transformDatesMap.set("PhoneBase", function (model: PhoneBase) {});

export type PhoneBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  number: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  type: PropertyMeta<PhoneTypeMetaI>;
  //isDate: false
  //isDatetime: false
  isVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isBad: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var PhoneBaseMeta: PhoneBaseMetaI = {} as PhoneBaseMetaI;
PhoneBaseMeta = typeMeta("PhoneBase", {
  number: propertyMeta("number", false, true, false, MetaTypesBase.string),
  type: propertyMeta("type", false, false, false, PhoneTypeMeta),
  isVerified: propertyMeta(
    "isVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isBad: propertyMeta("isBad", false, false, false, MetaTypesBase.boolean),
});

const metaI = PhoneBaseMeta;

registerMeta(() => {});

export class PhoneBaseTracked implements PhoneBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  number__I?: string = undefined;
  numberIsSet: boolean = false;
  set number(v: undefined | string) {
    if (v !== undefined) {
      this.number__I = v;
      this.numberIsSet = true;
    } else {
      this.number__I = v || undefined;
      this.numberIsSet = true;
    }
    this.changeTracker = true;
  }
  get number() {
    return this.number__I;
  }
  type__I?: PhoneType = undefined;
  typeIsSet: boolean = false;
  set type(v: undefined | PhoneType) {
    if (v !== undefined) {
      this.type__I = v;
      this.typeIsSet = true;
    } else {
      this.type__I = v || undefined;
      this.typeIsSet = false;
    }
    this.changeTracker = true;
  }
  get type() {
    return this.type__I;
  }
  isVerified__I?: boolean = undefined;
  isVerifiedIsSet: boolean = false;
  set isVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.isVerified__I = v;
      this.isVerifiedIsSet = true;
    } else {
      this.isVerified__I = v || undefined;
      this.isVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isVerified() {
    return this.isVerified__I;
  }
  isBad__I?: boolean = undefined;
  isBadIsSet: boolean = false;
  set isBad(v: undefined | boolean) {
    if (v !== undefined) {
      this.isBad__I = v;
      this.isBadIsSet = true;
    } else {
      this.isBad__I = v || undefined;
      this.isBadIsSet = false;
    }
    this.changeTracker = true;
  }
  get isBad() {
    return this.isBad__I;
  }
  constructor(config?: PhoneBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PhoneBaseOptional,
    options?: AssignOptions,
  ): PhoneBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.number && this.numberApplyFilter(optionsRequired.filter)) {
      this.number = config.number;
      if (optionsRequired.unassign) this.numberIsSet = false;
      else this.numberIsSet = true;
    }
    if (config.type && this.typeApplyFilter(optionsRequired.filter)) {
      this.type = config.type;
      if (optionsRequired.unassign) this.typeIsSet = false;
      else this.typeIsSet = true;
    }
    if (
      config.isVerified &&
      this.isVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.isVerified = config.isVerified;
      if (optionsRequired.unassign) this.isVerifiedIsSet = false;
      else this.isVerifiedIsSet = true;
    }
    if (config.isBad && this.isBadApplyFilter(optionsRequired.filter)) {
      this.isBad = config.isBad;
      if (optionsRequired.unassign) this.isBadIsSet = false;
      else this.isBadIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PhoneBaseTrackedI {
    const cloned = {} as PhoneBaseTrackedI;
    if (
      this.numberIsSetDeep() &&
      this.numberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.numberIsSet = true;
      cloned.number = this.number;
    } else {
      //cloned.numberIsSet = false
    }
    if (
      this.typeIsSetDeep() &&
      this.typeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIsSet = true;
      cloned.type = this.type;
    } else {
      //cloned.typeIsSet = false
    }
    if (
      this.isVerifiedIsSetDeep() &&
      this.isVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isVerifiedIsSet = true;
      cloned.isVerified = this.isVerified;
    } else {
      //cloned.isVerifiedIsSet = false
    }
    if (
      this.isBadIsSetDeep() &&
      this.isBadApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isBadIsSet = true;
      cloned.isBad = this.isBad;
    } else {
      //cloned.isBadIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PhoneBaseTrackedI {
    if (!this.numberApplyFilter(filter)) this.numberIsSet = false;

    if (!this.typeApplyFilter(filter)) this.typeIsSet = false;

    if (!this.isVerifiedApplyFilter(filter)) this.isVerifiedIsSet = false;

    if (!this.isBadApplyFilter(filter)) this.isBadIsSet = false;

    return this;
  }
  numberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneBaseMeta.number, PhoneBaseMeta, this.number, this);
  }
  numberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.numberIsSet && this.numberApplyFilter(filter)) return true;

    return false;
  }
  typeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneBaseMeta.type, PhoneBaseMeta, this.type, this);
  }
  typeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIsSet && this.typeApplyFilter(filter)) return true;

    return false;
  }
  isVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PhoneBaseMeta.isVerified,
      PhoneBaseMeta,
      this.isVerified,
      this,
    );
  }
  isVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isVerifiedIsSet && this.isVerifiedApplyFilter(filter)) return true;

    return false;
  }
  isBadApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(PhoneBaseMeta.isBad, PhoneBaseMeta, this.isBad, this);
  }
  isBadIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isBadIsSet && this.isBadApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.numberIsSetDeep(filter)) return true;
    if (this.typeIsSetDeep(filter)) return true;
    if (this.isVerifiedIsSetDeep(filter)) return true;
    if (this.isBadIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
